// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import productDescriptionVariantStyles from "@turnerBlueprint/App/SharedStyles/ProductDescriptionStyles";
import { productCarouselProductStyles } from "@turnerBlueprint/Overrides/Components/ProductCarouselProduct";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { ellipsis, mergeWithCss, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

productCarouselProductStyles.productGridContainerStyles = {
    container: {
        css: css`
            max-width: 317px;
            border: 0;
            padding: 0;

            ${xScreen("lte", "md")} {
                max-width: 358px;
            }
            ${xScreen("lte", 767)} {
                max-width: 328px;
            }
        `,
    },
    image: {
        css: css`
            position: relative;
            max-height: 317px;
            object-fit: contain;
            display: flex;
            align-items: center;
            justify-content: center;
        `,
    },
};
productCarouselProductStyles.productImageStyles = {
    linkWrappingImage: {
        css: css`
            &,
            img {
                max-height: 317px;
                object-fit: contain;
            }
        `,
    },
};
productCarouselProductStyles.badges = {
    css: css`
        position: absolute;
        left: 0;
        bottom: 0;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        & > div:empty {
            display: none;
        }
    `,
};
productCarouselProductStyles.productBrandWrapper = {
    css: css`
        margin-bottom: 2px;
    `,
};
productCarouselProductStyles.textBadgeStyle = {
    badgeText: {
        size: 12,
        lineHeight: "13px",
        color: "common.white",
        weight: fontConfig.weight.medium,
    },
    badge: {
        css: css`
            margin: 0;
        `,
    },
};

productCarouselProductStyles.productAddToListLinkStyles = {
    link: {
        css: css`
            margin-left: auto;
        `,
    },
};
productCarouselProductStyles.productAvailabilityStyles = {
    messageGridItem: {
        width: 12,
    },
    availabilityByWarehouseLinkGridItem: {
        width: 12,
    },
    availabilityByWarehouseLink: {
        css: css`
            margin-left: 0;
        `,
    },
};
productCarouselProductStyles.productPriceWrapper = {};

productCarouselProductStyles.productPartNumbersStyles = {};

productCarouselProductStyles.productDescriptionStyles = {
    ...mergeWithCss(productDescriptionVariantStyles.small, {
        productDetailLink: {
            typographyProps: {
                css: css`
                    ${ellipsis(3)}
                `,
            },
        },
        productDetailDescription: {
            css: css`
                ${ellipsis(3)}
            `,
        },
    }),
};
